import React from 'react';
import { COLORS, TYPOGRAPHY } from '../../../styles/UISystem';
import Container from './Container';

/**
 * ContainerExample Component
 * 
 * Demonstrates how to use the Container component with various props
 */
const ContainerExample = () => {
  // Example footer content
  const footerContent = (
    <div style={{ fontSize: '12px', color: COLORS.MEDIUM_GRAY }}>
      Footer content goes here
    </div>
  );

  return (
    <div style={{ marginBottom: '40px' }}>
      <h2 style={{ ...TYPOGRAPHY.HEADER_MEDIUM, textAlign: 'center', marginBottom: '24px' }}>
        Container Examples
      </h2>
      
      {/* Basic Container Example */}
      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ ...TYPOGRAPHY.HEADER_SMALL, marginBottom: '16px' }}>
          Basic Container
        </h3>
        <div style={{ border: `1px solid ${COLORS.MEDIUM_GRAY}`, height: '300px' }}>
          <Container>
            <div style={{ textAlign: 'center' }}>
              <p>Basic container with default styling</p>
            </div>
          </Container>
        </div>
      </div>
      
      {/* Container with Title */}
      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ ...TYPOGRAPHY.HEADER_SMALL, marginBottom: '16px' }}>
          Container with Title
        </h3>
        <div style={{ border: `1px solid ${COLORS.MEDIUM_GRAY}`, height: '300px' }}>
          <Container title="Page Title">
            <div style={{ textAlign: 'center' }}>
              <p>Container with a title</p>
            </div>
          </Container>
        </div>
      </div>
      
      {/* Container with Back Button */}
      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ ...TYPOGRAPHY.HEADER_SMALL, marginBottom: '16px' }}>
          Container with Back Button
        </h3>
        <div style={{ border: `1px solid ${COLORS.MEDIUM_GRAY}`, height: '300px' }}>
          <Container 
            title="Page with Back" 
            showBackButton={true} 
            onBack={() => alert('Back button clicked')}
          >
            <div style={{ textAlign: 'center' }}>
              <p>Container with title and back button</p>
            </div>
          </Container>
        </div>
      </div>
      
      {/* Container with Footer */}
      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ ...TYPOGRAPHY.HEADER_SMALL, marginBottom: '16px' }}>
          Container with Footer
        </h3>
        <div style={{ border: `1px solid ${COLORS.MEDIUM_GRAY}`, height: '300px' }}>
          <Container 
            title="Page with Footer" 
            footer={footerContent}
          >
            <div style={{ textAlign: 'center' }}>
              <p>Container with title and footer</p>
            </div>
          </Container>
        </div>
      </div>
      
      {/* Container with Custom Styling */}
      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ ...TYPOGRAPHY.HEADER_SMALL, marginBottom: '16px' }}>
          Container with Custom Styling
        </h3>
        <div style={{ border: `1px solid ${COLORS.MEDIUM_GRAY}`, height: '300px' }}>
          <Container 
            title="Custom Styling" 
            maxWidth="600px"
            backgroundColor={COLORS.LIGHT_GRAY}
            contentStyle={{ 
              backgroundColor: COLORS.WHITE,
              borderRadius: '16px',
              padding: '24px'
            }}
          >
            <div style={{ textAlign: 'center' }}>
              <p>Container with custom styling</p>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default ContainerExample;
